import {
  useCounties,
  useCountiesForm,
} from "../../../hooks/location/useCounties";
import {
  useDistricts,
  useDistrictsForm,
} from "../../../hooks/location/useDistricts";
import {
  useSubCountyForm,
  useSubCounties,
} from "../../../hooks/location/useSubCounties";
import { useMasterDataForm } from "../../../hooks/location/useMasterDataForm";
import {
  useParishes,
  useParishesForm,
} from "../../../hooks/location/useParishes";
import {
  useVillages,
  useVillagesForm,
} from "../../../hooks/location/useVillages";
import { submitMasterData } from "../../../hooks/submission/useSubmission";
import {
  API_DISTRICTS_PAGINATED,
  API_COUNTIES_PAGINATED,
  API_SUB_COUNTIES_PAGINATED,
  API_PARISHES_PAGINATED,
  API_VILLAGES_PAGINATED,
} from "../../../utils/apis";
import {
  COUNTY,
  DISTRICT,
  SUB_COUNTY,
  PARISH,
  VILLAGE,
  DISTRICTS,
  COUNTIES,
  SUB_COUNTIES,
  PARISHES,
  VILLAGES,
} from "../../../utils/constants";

export const locationRegisterRoutes = {
  districts: useDistricts,
  counties: useCounties,
  sub_counties: useSubCounties,
  parishes: useParishes,
  villages: useVillages,
};

export const locationFormRoutes = {
  master_data: useMasterDataForm,
  districts: useDistrictsForm,
  counties: useCountiesForm,
  sub_counties: useSubCountyForm,
  parishes: useParishesForm,
  villages: useVillagesForm,
};

export const locationFormSubmit = {
  master_data: submitMasterData,
  districts: submitMasterData,
  counties: submitMasterData,
  sub_counties: submitMasterData,
  parishes: submitMasterData,
  villages: submitMasterData,
};

export const locationApis = {
  districts: API_DISTRICTS_PAGINATED,
  counties: API_COUNTIES_PAGINATED,
  sub_counties: API_SUB_COUNTIES_PAGINATED,
  parishes: API_PARISHES_PAGINATED,
  villages: API_VILLAGES_PAGINATED,
};

export function getMasterDataApi(type: any) {
  const typeMapping = {
    [DISTRICT]: API_DISTRICTS_PAGINATED,
    [DISTRICTS]: API_DISTRICTS_PAGINATED,
    [COUNTY]: API_COUNTIES_PAGINATED,
    [COUNTIES]: API_COUNTIES_PAGINATED,
    [SUB_COUNTY]: API_SUB_COUNTIES_PAGINATED,
    [SUB_COUNTIES]: API_SUB_COUNTIES_PAGINATED,
    [PARISH]: API_PARISHES_PAGINATED,
    [PARISHES]: API_PARISHES_PAGINATED,
    [VILLAGE]: API_VILLAGES_PAGINATED,
    [VILLAGES]: API_VILLAGES_PAGINATED,
  };

  return typeMapping[type];
}
